import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec425bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_2 = {
  key: 1,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze melding wilt verwijderen?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Alle aan deze melding gekoppelde foto's worden ook verwijderd.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bestand(en) bij servicemelding", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Blok "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bouwnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderwerp "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gewenste oplossing", -1))

import { computed, onMounted, ref } from 'vue'
import { surveyStore } from '@/stores/survey'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { IssueStateLabels } from '@/helpers/issueStates'
import { HighlightOutlined, PushpinOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import MediaItem from '@/types/mediaItem'
import IssueTagger from '@/components/imageTagger/IssueTagger.vue'

interface NewIssueType {
  buildingId:number|null
  issueType:number
  title:string|null
  description:string|null
  recommendedSolution:string|null
}

interface IssueType {
  id:number
  title:string
  description:string
  recommended_solution:string|null
  building_id:number
  building:{
    buildingblock: { id:number }
  }
}

interface ImageTaggerType {
  visible: boolean
  issueIndex: number|null
  type: string|null
  directory: string|null
  file: MediaItem|null
  survey_id: number|null
  survey_answer_id: number|null
  tagged_issue_id: number|null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalInspectionAnswerIssues',
  props: {
    answer: null,
    chapterIndex: null,
    questionIndex: null
  },
  emits: ['issueAdded', 'issueUpdated', 'issueDeleted'],
  setup(__props: any, { emit }) {

const props = __props as { answer: { id:number, answer:string|null, note:string|null, issues:{ id:number, title:string, description:string, status:number }[] }, chapterIndex:number, questionIndex:number };



const loading = ref({ blocks: false, buildings: false })

const columns = ref([
  { title: '#', key: 'id' },
  { title: 'Bouwnummer', key: 'building' },
  { title: 'Onderwerp', key: 'description' },
  { title: 'Status', key: 'status' },
  { title: 'Actie\'s', key: 'actions' }
])

const columnsClosed = ref([
  { title: '#', key: 'id' },
  { title: 'Bouwnummer', key: 'building' },
  { title: 'Onderwerp', key: 'description' },
  { title: 'Status', key: 'status' }
])

const issue = ref<NewIssueType>({
  buildingId: null,
  issueType: 8,
  title: null,
  description: null,
  recommendedSolution: null
})

const blockId = ref<number|null>(null)
const blocks = ref([])
const buildings = ref([])

const saving = ref(false)
const editMode = ref(false)
const issueId = ref<number|null>(null)

const imageTaggerData = ref<ImageTaggerType>({
  visible: false,
  issueIndex: null,
  type: null,
  directory: null,
  file: null,
  survey_id: null,
  survey_answer_id: null,
  tagged_issue_id: null
})

const buttonEnabled = computed(() => {
  const blockIdSet = blockId.value != null
  const buildingIdSet = issue.value.buildingId != null
  const titleSet = issue.value.title != null && issue.value.title.length > 2
  const descriptionSet = issue.value.description != null && issue.value.description.length > 2

  return blockIdSet && buildingIdSet && titleSet && descriptionSet && !saving.value
})

onMounted(() => {
  getBlocks()
})

function getBlocks () : void {
  loading.value.blocks = true
  blockId.value = null
  issue.value.buildingId = null
  axios.get(process.env.VUE_APP_API_URL + '/buildingblocks?filter[project_id]=' + surveyStore().survey.project_id + '&limit=2500').then((r) => {
    blocks.value = r.data.data
  }).catch(() => {
    notification.error({ message: 'Fout tijdens ophalen van de blokken!', description: 'Er is iets mis gegaan. Probeer het nogmaals.' })
  }).finally(() => {
    loading.value.blocks = false
  })
}

function getBuildings () : void {
  if (!blockId.value) return

  loading.value.buildings = true
  issue.value.buildingId = null
  axios.get(process.env.VUE_APP_API_URL + '/buildings?filter[buildingblock_id]=' + blockId.value + '&limit=2500').then((r) => {
    buildings.value = r.data.data
  }).catch(() => {
    notification.error({ message: 'Fout tijdens ophalen van de bouwnummers!', description: 'Er is iets mis gegaan. Probeer het nogmaals.' })
  }).finally(() => {
    loading.value.buildings = false
  })
}

function storeIssue () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.answer.id + '/issues/add', issue.value).then((r) => {
    emit('issueAdded', r.data.data)
    issue.value.issueType = 8
    issue.value.title = null
    issue.value.description = null
    issue.value.recommendedSolution = null
    issue.value.buildingId = null
    blockId.value = null
    notification.success({
      message: 'Servicemelding aangemaakt.',
      description: 'De servicemelding is succesvol aangemaakt.',
      duration: 3
    })
  }).finally(() => {
    saving.value = false
  })
}

function updateIssue () : void {
  saving.value = true
  const data:{ title:string|null, description:string|null, recommendedSolution:string|null, issueId?:number|null } = issue.value
  data.issueId = issueId.value
  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.answer.id + '/issues/update', data).then((r) => {
    emit('issueUpdated', r.data.data)
    stopEditMode()
    notification.success({
      message: 'Servicemelding bijgewerkt.',
      description: 'De servicemelding is succesvol bijgewerkt.',
      duration: 3
    })
  }).finally(() => {
    saving.value = false
  })
}

function deleteIssue (i:IssueType) : void {
  axios.delete(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.answer.id + '/issues/' + i.id + '/delete').then(() => {
    emit('issueDeleted', i.id)
    notification.success({
      message: 'Servicemelding verwijderd.',
      description: 'De servicemelding is succesvol verwijderd.',
      duration: 3
    })
  })
}

function startEditMode (i:IssueType) : void {
  getBlocks()
  blockId.value = i.building.buildingblock.id

  getBuildings()

  issueId.value = i.id
  issue.value = {
    buildingId: i.building_id,
    issueType: 8,
    title: i.title,
    description: i.description,
    recommendedSolution: i.recommended_solution
  }

  editMode.value = true
}

function stopEditMode () : void {
  editMode.value = false
  issueId.value = null
  issue.value = {
    buildingId: null,
    issueType: 8,
    title: null,
    description: null,
    recommendedSolution: null
  }
}

function addIssueMedia (issue:IssueType, file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/surveys/issues/' + issue.id + '/media/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    emit('issueUpdated', r.data.data)
  })
}

function updateIssueMedia (issue:IssueType, data:{ file:File, mediaId:number }) : void {
  const formData = new FormData()
  formData.append('files', data.file)
  formData.append('mediaId', data.mediaId.toString())

  axios.post(process.env.VUE_APP_API_URL + '/surveys/issues/' + issue.id + '/media/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    emit('issueUpdated', r.data.data)
  })
}

function deleteFile (issue:IssueType, file:{ id:number }) : void {
  axios.post(process.env.VUE_APP_API_URL + '/surveys/issues/' + issue.id + '/media/delete', { mediaId: file.id }).then((r) => {
    emit('issueUpdated', r.data.data)
  })
}

function showImageTagger (issueIndex:number, type:string, directory:string, file:MediaItem, surveyId:number, surveyAnswerId:number, issueId:number) : void {
  imageTaggerData.value = {
    visible: true,
    issueIndex: issueIndex,
    type: type,
    directory: directory,
    file: file,
    survey_id: surveyId,
    survey_answer_id: surveyAnswerId,
    tagged_issue_id: issueId
  }
}

function hideImageTagger (file:MediaItem) : void {
  if (imageTaggerData.value.issueIndex !== null && imageTaggerData.value.type && imageTaggerData.value.directory) {
    surveyStore().survey.survey_form.chapters[props.chapterIndex].questions[props.questionIndex].answer.issues[imageTaggerData.value.issueIndex].building.media[imageTaggerData.value.type][imageTaggerData.value.directory][0] = file
    imageTaggerData.value = {
      visible: false,
      issueIndex: null,
      type: null,
      directory: null,
      file: null,
      survey_id: null,
      survey_answer_id: null,
      tagged_issue_id: null
    }
  }
}

function filterOnName (input:string, item:{ name:string }) {
  return item.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

function filterOnNumberWithAddress (input:string, item:{ number_with_address:string }) {
  return item.number_with_address.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

function getLevelName (levelDirectory:string) : string {
  const level = parseInt(levelDirectory.replace('floorplanLevel', ''))
  if (level === 0) {
    return 'Begane grond'
  } else if (level === 90) {
    return 'Buiten'
  } else if (level === 99) {
    return 'Dak'
  } else if (level > 0) {
    return level + 'e verdieping'
  } else {
    return 'Verdieping -' + level
  }
}

function getFacadeName (facadeDirectory:string) : string {
  const facade = facadeDirectory.replace('Facade', '')
  if (facade === 'front') {
    return 'Voorgevel'
  } else if (facade === 'rear') {
    return 'Achtergevel'
  } else if (facade === 'left') {
    return 'Linker gevel'
  } else {
    return 'Rechter gevel'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.answer.issues.length)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner ? columns.value : columnsClosed.value,
                  "data-source": __props.answer.issues,
                  pagination: false,
                  rowKey: "id",
                  scroll: { x: true }
                }, {
                  bodyCell: _withCtx(({ column, record, index }) => [
                    (column.key === 'id')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(record.id), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'building')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(record.building.number), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'description')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(record.title), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'status')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_unref(IssueStateLabels)[record.status]), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'actions')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                            ? (_openBlock(), _createBlock(Uploader, {
                                key: 0,
                                "current-count": record.files.length,
                                "small-upload-button-with-counter": "",
                                onNewFileUploaded: ($event: any) => (addIssueMedia(record, $event))
                              }, null, 8, ["current-count", "onNewFileUploaded"]))
                            : _createCommentVNode("", true),
                          (record.building && Object.values(record.building.media.floorplans).some(arr => arr.length > 0) || Object.values(record.building.media.facades).some(arr => arr.length > 0))
                            ? (_openBlock(), _createBlock(_component_a_dropdown, {
                                key: 1,
                                trigger: ['click']
                              }, {
                                overlay: _withCtx(() => [
                                  _createVNode(_component_a_menu, null, {
                                    default: _withCtx(() => [
                                      (Object.values(record.building.media.floorplans).some(arr => arr.length > 0))
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_1, "Plattegronden (Bouwnummer)"))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(record.building.media.floorplans), (floorplanKey) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: floorplanKey }, [
                                          (record.building.media.floorplans[floorplanKey].length)
                                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                key: 0,
                                                onClick: ($event: any) => (showImageTagger(index, 'floorplans', floorplanKey, record.building.media.floorplans[floorplanKey][0], _unref(surveyStore)().survey.id, __props.answer.id, record.id))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(getLevelName(floorplanKey)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (Object.values(record.building.media.facades).some(arr => arr.length > 0))
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_2, "Gevelaanzichten (Bouwnummer)"))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(record.building.media.facades), (facadeKey) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: facadeKey }, [
                                          (record.building.media.facades[facadeKey].length)
                                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                key: 0,
                                                onClick: ($event: any) => (showImageTagger(index, 'facades', facadeKey, record.building.media.facades[facadeKey][0], _unref(surveyStore)().survey.id, __props.answer.id, record.id))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(getFacadeName(facadeKey)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    size: "small",
                                    style: {"margin-right":"4px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PushpinOutlined))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_button, {
                            size: "small",
                            style: {"margin-right":"4px"},
                            onClick: ($event: any) => (startEditMode(record))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(HighlightOutlined))
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_popconfirm, {
                            placement: "topRight",
                            "ok-text": "Ja",
                            "cancel-text": "Nee",
                            onConfirm: ($event: any) => (deleteIssue(record))
                          }, {
                            title: _withCtx(() => [
                              _hoisted_3,
                              _hoisted_4
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DeleteOutlined))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  expandedRowRender: _withCtx(({ record }) => [
                    _createVNode(_component_a_row, { style: {"margin-top":"16px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                              ? (_openBlock(), _createBlock(Uploader, {
                                  key: 0,
                                  "current-count": record.files.length,
                                  "upload-button": "",
                                  onNewFileUploaded: ($event: any) => (addIssueMedia(record, $event))
                                }, null, 8, ["current-count", "onNewFileUploaded"]))
                              : _createCommentVNode("", true),
                            (record.files.length)
                              ? (_openBlock(), _createBlock(Filelist, {
                                  key: 1,
                                  media: record.files,
                                  onImageEdited: ($event: any) => (updateIssueMedia(record, $event)),
                                  onDeleteFile: ($event: any) => (deleteFile(record, $event)),
                                  "can-edit": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                                  "can-comment": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                                  "can-delete": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner
                                }, null, 8, ["media", "onImageEdited", "onDeleteFile", "can-edit", "can-comment", "can-delete"]))
                              : (!_unref(surveyStore)().isSurveyOwner)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode("-")
                                  ], 64))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.answer.issues.length)
            ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 12}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    loading: loading.value.blocks,
                    disabled: loading.value.blocks,
                    "field-names": { label: 'name', value: 'id' },
                    filterOption: filterOnName,
                    options: blocks.value,
                    value: blockId.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((blockId).value = $event)),
                    onChange: getBuildings,
                    "allow-clear": "",
                    "show-search": ""
                  }, null, 8, ["loading", "disabled", "options", "value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 12}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    loading: loading.value.buildings,
                    disabled: loading.value.buildings,
                    "field-names": { label: 'number_with_address', value: 'id' },
                    filterOption: filterOnNumberWithAddress,
                    options: buildings.value,
                    value: issue.value.buildingId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((issue.value.buildingId) = $event)),
                    "allow-clear": "",
                    "show-search": ""
                  }, null, 8, ["loading", "disabled", "options", "value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 18}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: issue.value.title,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((issue.value.title) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 18}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: issue.value.description,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((issue.value.description) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 18}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: issue.value.recommendedSolution,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((issue.value.recommendedSolution) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "survey-issue-detail-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 4}
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 18}
              }, {
                default: _withCtx(() => [
                  (!editMode.value)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        loading: saving.value,
                        disabled: !_unref(buttonEnabled),
                        onClick: storeIssue
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Melding opslaan")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"]))
                    : _createCommentVNode("", true),
                  (editMode.value)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        loading: saving.value,
                        disabled: !_unref(buttonEnabled),
                        onClick: updateIssue
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Melding bijwerken")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"]))
                    : _createCommentVNode("", true),
                  (editMode.value)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        style: {"margin-left":"5px"},
                        onClick: stopEditMode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Stop bewerken")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    (imageTaggerData.value.file)
      ? (_openBlock(), _createBlock(IssueTagger, {
          key: 2,
          "survey-id": imageTaggerData.value.survey_id,
          "tagged-issue-id": imageTaggerData.value.tagged_issue_id,
          visible: imageTaggerData.value.visible,
          file: imageTaggerData.value.file,
          "survey-answer-id": imageTaggerData.value.survey_answer_id,
          onCloseTagger: _cache[5] || (_cache[5] = ($event: any) => (hideImageTagger($event)))
        }, null, 8, ["survey-id", "tagged-issue-id", "visible", "file", "survey-answer-id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})